import { render, staticRenderFns } from "./stockStatusGrade2.vue?vue&type=template&id=48a780f5"
import script from "./stockStatusGrade2.vue?vue&type=script&lang=js"
export * from "./stockStatusGrade2.vue?vue&type=script&lang=js"
import style0 from "./stockStatusGrade2.vue?vue&type=style&index=0&id=48a780f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports